import React, { Component } from 'react';
import { Row, Col, Navbar, Nav, Button, Form, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import IsLoadingBar from '../isLoading';
import moment from 'moment';
import { toast } from 'react-toastify';

import Auth from '../../Auth/Auth';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const auth = new Auth();

function parseJwt (token) {  
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

function DateFormatter(cell, row) {  
    return (
        <span>{moment(cell).format('MM-D-YYYY, h:mm:ss a')}</span>
    );
}

function imageConverter(cell, row) { 
    return (
        cell !== null ? 
        <a href={cell} download="filename">Download Image</a>
        : ""
    );
}


export default class Cuteness extends Component {
    
    constructor(props){
        super(props);

        this.state = {
            Cuteness: [],
            isLoading: true
        };
    }

    async componentDidMount(){
        this.setState({
            isLoading : true
        });
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        let accessToken = await auth.getToken();
        fetch('/api/GetAllUserCuteness', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                "loggedinClient" : jwt.oid,
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(data => {
            if(data && data.length > 0){
                let NextAvailDate;
                if(new Date(data[0].MaxDate) < new Date()){
                    NextAvailDate = new Date();
                } else {
                    NextAvailDate = data[0].MaxDate;
                }
                this.setState({
                    Cuteness: data,
                    NextAvailDate: NextAvailDate,
                    isLoading : false
                });
            }                      
        }).catch((error) => {
            window.apiError(error);
        });
    }

    //Approve the cuteness 
    async CutenessActioned(e, row){
        if((moment(new Date(row.Date)) > moment() )){
            var checkId = e.target.id;
            var checked = e.target.checked;
            let action = {
                isApproved : e.target.checked,
                Id: e.target.value,
                Date : moment(new Date(row.Date))
            };

            let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
            let accessToken = await auth.getToken();
            fetch(`/api/actionCuteness`,{
                method : "POST",
                headers : {
                    "Content-Type": "application/json",
                    'Authorization': "Bearer " + accessToken,
                    withCredentials : true,
                    crossDomain: true,
                    "loggedinClient" : jwt.oid,
                },
                body: JSON.stringify(action)
            }).then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                      };
                }
                return  response.json();
            })
            .then(success => {
                if(checked){
                    document.getElementById(checkId).checked = true;
                } else {
                    document.getElementById(checkId).checked = false;
                }                
            }).catch((err) => {
                window.apiError(err);
            });
        } else {
            toast.error("You need to choose a date", {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              });
        }
        
        
    }

    cutenessApprove(cell, row, rowIndex, formatExtraData) { 
        return (
            <Form.Check
                custom
                label=""
                type={'checkbox'}
                onChange={(e) => formatExtraData.cuteapp.CutenessActioned(e, row)}
                checked={cell}
                value={row.Id}
                id={`cuteness${row.Id}`}
            />
        );
    }

    render () { 
        let self = this;

        const columns = [{
            dataField: 'Id',
            text: 'Id',
            sort: true,
            hidden: true
          }, {
            dataField: 'Name',
            text: 'Name',
            sort: true,
            editable: false
          },{
            dataField: 'Breed',
            text: 'Breed',
            sort: true,
            editable: false
          },{
            dataField: 'Owner',
            text: 'Family',
            sort: true,
            editable: false
          }, {
            dataField: 'CreatedDate',
            text: 'Date/Time',
            sort: true,
            formatter: DateFormatter,
            editable: false
            }, {
            dataField: 'Image',
            text: 'Image',
            sort: true,
            formatter: imageConverter,
            editable: false
          }, {
            dataField: 'Date',
            text: 'Date',
            formatter: (cell) => {
                if(cell === null){
                    cell = moment(Date.now()).format('MM/DD/YYYY')
                }
                let dateObj = cell;
                if (typeof cell !== 'object') {
                dateObj = new Date(cell);
                }
                return `${('0' + (dateObj.getUTCMonth() + 1)).slice(-2)}/${('0' + dateObj.getUTCDate()).slice(-2)}/${dateObj.getUTCFullYear()}`;
              },
              editor: {
                type: Type.DATE,
                defaultValue: moment(Date.now()).format('MM/DD/YYYY')
              }
          }, {
            dataField: 'isApproved',
            text: 'isApproved',
            sort: true,
            width: "100px",
            formatter: this.cutenessApprove,
            formatExtraData: {
                cuteapp : self
            },
            editable: false
          }];
        
          const defaultSorted = [{
            dataField: 'feedbackUTCTimestamp',
            order: 'desc'
          }];
          
        if(this.state.isLoading){
            return (
                <IsLoadingBar />
            );
        }
          
        return(
            <div className="cuteness-manager">
                {this.state.NextAvailDate && (
                    <p>{`Next Date Available:  ${moment.utc(this.state.NextAvailDate).add(1,'days').format('MM/DD/YYYY')}`}</p>
                )}
                
                <BootstrapTable
                    bootstrap4
                    keyField="Id"
                    data={ this.state.Cuteness }
                    columns={ columns }
                    defaultSorted={ defaultSorted } 
                    cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) }
                />         
            </div>
        );  
    }
}